import { ONBOARDING_STEPS } from './steps'

interface MobileProgressProps {
  /** As `StepRail`'s: 0 the welcome screen, past the last step the done screen. */
  current: number
  steps?: readonly string[]
}

/**
 * The rail's stand-in at ≤960 px (`.ob-mprog`): "Step N of 9", the step's name and
 * a bar per step. Hidden from assistive technology, since the card's own heading
 * says the same, and kept in place but invisible on the welcome screen.
 */
export function MobileProgress({ current, steps = ONBOARDING_STEPS }: MobileProgressProps) {
  const total = steps.length
  const shown = Math.max(1, Math.min(total, current))
  const name = current === 0 ? 'Welcome' : current > total ? 'Done' : steps[shown - 1]
  return (
    <div className="ob-mprog" aria-hidden="true" style={current === 0 ? { visibility: 'hidden' } : undefined}>
      <div className="ob-t">
        <span>
          Step <b>{shown}</b> of {total}
        </span>
        <b>{name}</b>
      </div>
      <div className="ob-bars">
        {steps.map((label, index) => (
          <i key={label} className={index < current || current > total ? 'ob-on' : undefined} />
        ))}
      </div>
    </div>
  )
}
